<script lang="ts">
  import { onMount } from 'svelte';

  import { Schema, Form } from '@feature/newsletter';
  import * as Errors from '@feature/shared/error';
  import InputText from '@components/fields/Input.svelte';
  import InputCheckbox from '@components/fields/Checkbox.svelte';
  import Button from '@components/fields/Button.svelte';
  import Disclaimer from '../fields/Disclaimer.svelte';

  let page_url = window.location.href;
  let form_name = 'newsletter-signup-form';
  let email = '';
  let marketing_opt: '0' | '1' = '0'; // Ensure this is an array to match the selected options
  let captcha_key = import.meta.env.VITE_PUBLIC_RECAPTCHA_KEY;

  const handleKeydown = (e: Event) => {
    email = (e.target as HTMLInputElement).value;
  };

  const handleCheckboxChange = (selection: string[], text: string = '') => {
    marketing_opt = selection.includes('privacy') ? '1' : '0';
  };

  const buttonclick = async (e: Event) => {
    e.preventDefault();
    grecaptcha.ready(function () {
      grecaptcha.execute(captcha_key, { action: 'submit' }).then(function (token) {
        let data: Schema.Newsletter = {
          token,
          email,
          marketing_opt,
          form_name,
          page_url
        };

        Form.validate(data);

        Form.submit(data);
      });
    });
  };

  let errorMessage: Errors.Error = null;
  let validationIssues: Partial<Form.Issues> = {};

  Errors.store.subscribe((error) => {
    return (errorMessage = error);
  });

  Form.store.subscribe((issues) => {
    return (validationIssues = issues);
  });
</script>

<svelte:head>
  <script src="https://www.google.com/recaptcha/api.js?render={captcha_key}" async defer></script>
</svelte:head>

<section class="bg-black mode-dark dark-mode">
  <div class="up-newsletter">
    {#if errorMessage}
      <p class="up-newsletter__error">{errorMessage}</p>
    {/if}
    <InputText
      id="email"
      type="email"
      className="email"
      required={true}
      placeholder="Email Address"
      error={validationIssues.email}
      updated={handleKeydown}
    />

    <InputCheckbox
      id="privacy"
      options={[{ value: 'privacy', label: 'Privacy Policy', checked: false }]}
      changed={handleCheckboxChange}
      required={true}
      error={validationIssues.marketing_opt ? 'Please accept our privacy policy.' : ''}
    />

    <Button
      id="submit"
      type="submit"
      className="btn btn-primary"
      label="Submit."
      style="primary"
      {buttonclick}
    />

    <Disclaimer />
  </div>
</section>

<style lang="scss">
  @use '@styles/tokens/colours.scss' as colours;

  .up-newsletter {
    position: relative;
    &__error {
      color: colours.$color-red;
      text-align: center;
      font-size: 12px;
      margin-bottom: 12px;
    }
    .up-form-element,
    .up-custom-checkbox__wrapper {
      padding: 0;
      margin: 0 0 24px;
      .up-custom-checkbox__input {
        padding: 0;
        margin: 0;
      }
      &__validation-message {
        margin-top: 16px;
      }
    }

    .up-custom-checkbox__wrapper label {
      font-size: 14px;
    }
    h3 {
      font-size: 16px;
      margin: 0 0 8px 0;
    }
    .btn {
      width: 100%;
      margin-top: 16px;
    }

    .grecaptcha-badge {
      visibility: hidden;
    }
  }
</style>
